import React from 'react';
// eslint-disable-next-line import/order -- FIXME
import { compose } from 'recompose';

// API Connection
// @material-ui/core components
// eslint-disable-next-line import/order -- FIXME
import withStyles from '@material-ui/core/styles/withStyles';
// core components

import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { withTranslation } from 'react-i18next';
import NavTabs from 'components/NavTabs/NavTabs';
import ROLES from 'helpers/roles';
import { Link } from 'react-router-dom';
import Button from 'components/CustomButtons/Button';

import { DialogLoader } from '../../components/DialogLoader';
import SizeNameOverridesContextProvider from './contexts/SizeNameOverridesContext';
import MealNotes from './MealNotes';
import DishSubpage from './DishSubpage';
import DishRatesAndComments from './DishRatesAndComments';
import BasicMealForm from './BasicMealForm';
// import DishFlowStatistics from './DishFlowStatistics';
import { combineStyles, isGranted } from '../../helpers/helpers';
import buttonsStyle from '../../assets/jss/material-dashboard-pro-react/views/buttonsStyle';

const MealForm = props => {
  const {
    t,
    urlSlug,
    classes,
    metaTitle,
    friendlyName,
    handleSubmit,
    metaDescription,
    dishDescription,
    handleCmsInputChange,
    handleCmsTranslationChange,
    isLoading,
    initialized,
    isSubmitting,
    isEditing,
    dish,
    selectedBrand,
    saveToLs,
    languages,
    getStarRate,
  } = props;
  if (isLoading || !initialized) {
    return (
      <DialogLoader
        loaderState={isLoading}
        text={t('common.shared.isLoading', 'Wczytywanie dania...')}
      />
    );
  }

  return (
    <SizeNameOverridesContextProvider>
      <DialogLoader
        loaderState={isSubmitting}
        text={t('form.savingChanges', 'Zapisywanie zmian...')}
      />
      <NavTabs
        title={isEditing ? t('form.editMeal') : t('form.createMeal')}
        tabs={[
          {
            tabButton: t('$*mealFormComponent.information'),
            tabContent: <BasicMealForm {...props} dishId={dish.id} />,
          },

          ...(isGranted(ROLES.ROLE_SHOW_RATE) && isEditing
            ? [
                {
                  tabButton: t('$*mealFormComponent.ratesAndComments'),
                  tabContent: (
                    <DishRatesAndComments
                      dish={dish}
                      classes={classes}
                      getStarRate={getStarRate}
                    />
                  ),
                },
              ]
            : []),

          ...(isGranted(ROLES.ROLE_NOTE_DISH) && isEditing
            ? [
                {
                  tabButton: t('common.notes', 'Notatki'),
                  tabContent: <MealNotes dishId={dish.id} />,
                },
              ]
            : []),

          {
            tabButton: t('$*mealFormComponent.dishSubpage', 'Podstrona dania'),
            tabContent: (
              <DishSubpage
                classes={classes}
                languages={languages}
                urlSlug={urlSlug}
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                friendlyName={friendlyName}
                dishDescription={dishDescription}
                handleSubmit={handleSubmit}
                handleCmsInputChange={handleCmsInputChange}
                handleCmsTranslationChange={handleCmsTranslationChange}
              />
            ),
          },
        ]}
        contentAfterTabButtons={
          isEditing && (
            <Link
              to={`/admin/meals/add/?savedMeal&selectedBrand=${selectedBrand}`}
              target="_blank"
            >
              <Button
                color="primary"
                variant="contained"
                size="md"
                onClick={saveToLs}
              >
                {t('form.meals.copyToNewMeal')}
              </Button>
            </Link>
          )
        }
      />
    </SizeNameOverridesContextProvider>
  );
};

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

export default compose(withTranslation(), withStyles(combinedStyles))(MealForm);
